/* @license Copyright (c) @kurehajime / source code: https://github.com/kurehajime/colamone_js */
'use strict';
import { Rule } from "./rule";
import { Eval } from "./eval";
export class Aijs {
    /**
     * よく考える
     */
    static deepThinkAllAB(map, turn_player, depth, a, b, nearwin, evalparam) {
        let best_score = turn_player * 9999999 * -1;
        let besthand;
        if (depth === 0) {
            best_score = Eval.evalMap(map, nearwin, evalparam);
            return [besthand, best_score];
        }
        if (a === void 0 || b === void 0) {
            a = 9999999 * turn_player * -1;
            b = 9999999 * turn_player;
        }
        let nodeList = Rule.getNodeMap(map, turn_player);
        for (let i = 0; i < nodeList.length; i++) {
            let hand = nodeList[i][0];
            let map0 = nodeList[i][1];
            let sc = 0;
            // 必勝            
            let end = Rule.isEndX(map0, nearwin);
            if (end === turn_player) {
                return [hand, 999999 * turn_player];
            }
            // 必敗
            if (end === turn_player * -1) {
                if (besthand === void 0) {
                    best_score = 999999 * turn_player * -1;
                    besthand = hand;
                }
                continue;
            }
            if (Rule.isNoneNode(map0)) {
                sc = 0;
            }
            else {
                sc = Aijs.deepThinkAllAB(map0, turn_player * -1, depth - 1, b, a, nearwin, evalparam)[1];
            }
            if (besthand === void 0) {
                best_score = sc;
                besthand = hand;
            }
            if (turn_player === 1 && sc > best_score) {
                best_score = sc;
                besthand = hand;
            }
            else if (turn_player === -1 && sc < best_score) {
                best_score = sc;
                besthand = hand;
            }
            if (turn_player === 1 && a < best_score || turn_player === -1 && a > best_score) {
                a = best_score;
            }
            if (turn_player === 1 && b <= best_score || turn_player === -1 && b >= best_score) {
                break;
            }
        }
        return [besthand, best_score];
    }
    /**
     * 考える
     */
    static thinkAI(map, turn_player, depth, a, b, evalparam) {
        let nearwin = false;
        let hand = [undefined, 0];
        let wkMap = new Int8Array(map);
        if (!evalparam) {
            evalparam = Eval.DEFAULT_EVALPARAM;
        }
        if (Rule.isEndX(wkMap, false) !== 0) {
            nearwin = true;
        }
        hand = Aijs.deepThinkAllAB(wkMap, turn_player, depth, a, b, nearwin, evalparam);
        if (hand[1] * turn_player === -999999) {
            hand = Aijs.deepThinkAllAB(wkMap, turn_player, 1, a, b, nearwin, evalparam);
        }
        return hand;
    }
}
